// material-ui
import Box from '@mui/material/Box';

// project imports
import SimpleBar from 'components/third-party/SimpleBar';
import Navigation from './Navigation';
import NavSettings from './NavSettings';
import NavUser from './NavUser';

// ==============================|| DRAWER CONTENT ||============================== //

export default function DrawerContent() {
  // const { menuMaster } = useGetMenuMaster();
  // const drawerOpen = menuMaster.isDashboardDrawerOpened;
  // const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <SimpleBar sx={{ '& .simplebar-content': { display: 'flex', flexDirection: 'column' }, flex: 1 }}>
        <Navigation />
        {/* {drawerOpen && !downLG && <NavCard />} */}
      </SimpleBar>
      <Box sx={{ mt: 'auto' }}>
        <NavSettings />
        <NavUser />
      </Box>
    </Box>
  );
}
